// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SavingsFolderViewDeepLinkEvent
 */
export var SavingsFolderViewDeepLink = function (_a) {
    var apyChange = _a.apyChange, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder View DeepLink",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "View",
            apy_change: apyChange !== undefined && apyChange !== null ? apyChange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderViewEnhancedYieldUpsellEvent
 */
export var SavingsFolderViewEnhancedYieldUpsell = function () { return ({
    name: "SavingsFolder View EnhancedYieldUpsell",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "View",
    }
}); };
/**
 * @see SavingsFolderViewNotificationEvent
 */
export var SavingsFolderViewNotification = function (_a) {
    var apyChange = _a.apyChange, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder View Notification",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "View",
            apy_change: apyChange !== undefined && apyChange !== null ? apyChange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderViewLoadSavingsHomeEvent
 */
export var SavingsFolderViewLoadSavingsHome = function (_a) {
    var hasMultipleGoals = _a.hasMultipleGoals, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder View LoadSavingsHome",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "View",
            has_multiple_goals: hasMultipleGoals !== undefined && hasMultipleGoals !== null ? hasMultipleGoals.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderViewTapEvent
 */
export var SavingsFolderViewTap = function (_a) {
    var tileType = _a.tileType, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder View Tap",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "View",
            tile_type: tileType !== undefined && tileType !== null ? tileType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageAutomationElementTappedEvent
 */
export var SavingsFolderManageAutomationElementTapped = function (_a) {
    var automationType = _a.automationType, isFallback = _a.isFallback, isEnabled = _a.isEnabled, savedAmountCents = _a.savedAmountCents, currencyCode = _a.currencyCode;
    return ({
        name: "SavingsFolder Manage AutomationElementTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            automation_type: automationType !== undefined && automationType !== null ? automationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_fallback: isFallback !== undefined && isFallback !== null ? isFallback.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_enabled: isEnabled !== undefined && isEnabled !== null ? isEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            saved_amount_cents: savedAmountCents !== undefined && savedAmountCents !== null ? savedAmountCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageConfirmW9ButtonTappedEvent
 */
export var SavingsFolderManageConfirmW9ButtonTapped = function () { return ({
    name: "SavingsFolder Manage ConfirmW9ButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageConfirmW9StartEvent
 */
export var SavingsFolderManageConfirmW9Start = function () { return ({
    name: "SavingsFolder Manage ConfirmW9Start",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageDirectDepositStartEvent
 */
export var SavingsFolderManageDirectDepositStart = function () { return ({
    name: "SavingsFolder Manage DirectDepositStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageEnableRoundUpsStartEvent
 */
export var SavingsFolderManageEnableRoundUpsStart = function () { return ({
    name: "SavingsFolder Manage EnableRoundUpsStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageEnhancedYieldUpsellLearnAboutInterestButtonTappedEvent
 */
export var SavingsFolderManageEnhancedYieldUpsellLearnAboutInterestButtonTapped = function () { return ({
    name: "SavingsFolder Manage EnhancedYieldUpsellLearnAboutInterestButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageEnhancedYieldUpsellSetUpDirectDepositButtonTappedEvent
 */
export var SavingsFolderManageEnhancedYieldUpsellSetUpDirectDepositButtonTapped = function () { return ({
    name: "SavingsFolder Manage EnhancedYieldUpsellSetUpDirectDepositButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageGetCashCardButtonTappedEvent
 */
export var SavingsFolderManageGetCashCardButtonTapped = function () { return ({
    name: "SavingsFolder Manage GetCashCardButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageGetCashCardStartEvent
 */
export var SavingsFolderManageGetCashCardStart = function () { return ({
    name: "SavingsFolder Manage GetCashCardStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageNotNowCashCardButtonTappedEvent
 */
export var SavingsFolderManageNotNowCashCardButtonTapped = function () { return ({
    name: "SavingsFolder Manage NotNowCashCardButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageNotNowW9ButtonTappedEvent
 */
export var SavingsFolderManageNotNowW9ButtonTapped = function () { return ({
    name: "SavingsFolder Manage NotNowW9ButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageNUXBlockerContinueButtonTappedEvent
 */
export var SavingsFolderManageNUXBlockerContinueButtonTapped = function () { return ({
    name: "SavingsFolder Manage NUXBlockerContinueButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageReviewW9ButtonTappedEvent
 */
export var SavingsFolderManageReviewW9ButtonTapped = function () { return ({
    name: "SavingsFolder Manage ReviewW9ButtonTapped",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageSaveAutomaticallyStartEvent
 */
export var SavingsFolderManageSaveAutomaticallyStart = function () { return ({
    name: "SavingsFolder Manage SaveAutomaticallyStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageSaveAutomaticallyFlowStartEvent
 */
export var SavingsFolderManageSaveAutomaticallyFlowStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "SavingsFolder Manage SaveAutomaticallyFlowStart",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSaveAutomaticallyDirectDepositTappedEvent
 */
export var SavingsFolderManageSaveAutomaticallyDirectDepositTapped = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "SavingsFolder Manage SaveAutomaticallyDirectDepositTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSaveAutomaticallyDirectDepositBenefitsContinueTappedEvent
 */
export var SavingsFolderManageSaveAutomaticallyDirectDepositBenefitsContinueTapped = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "SavingsFolder Manage SaveAutomaticallyDirectDepositBenefitsContinueTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSaveAutomaticallyRoundUpsTappedEvent
 */
export var SavingsFolderManageSaveAutomaticallyRoundUpsTapped = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "SavingsFolder Manage SaveAutomaticallyRoundUpsTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSavingsHomeHeaderInterestButtonTappedEvent
 */
export var SavingsFolderManageSavingsHomeHeaderInterestButtonTapped = function (_a) {
    var eventType = _a.eventType, goalSet = _a.goalSet, yieldStatus = _a.yieldStatus;
    return ({
        name: "SavingsFolder Manage SavingsHomeHeaderInterestButtonTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            event_type: eventType !== undefined && eventType !== null ? eventType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goal_set: goalSet !== undefined && goalSet !== null ? goalSet.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            yield_status: yieldStatus !== undefined && yieldStatus !== null ? yieldStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSavingsHomeUpsellSectionButtonTappedEvent
 */
export var SavingsFolderManageSavingsHomeUpsellSectionButtonTapped = function (_a) {
    var eventType = _a.eventType, yieldStatus = _a.yieldStatus, isHalfSheetPopup = _a.isHalfSheetPopup;
    return ({
        name: "SavingsFolder Manage SavingsHomeUpsellSectionButtonTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            event_type: eventType !== undefined && eventType !== null ? eventType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            yield_status: yieldStatus !== undefined && yieldStatus !== null ? yieldStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_half_sheet_popup: isHalfSheetPopup !== undefined && isHalfSheetPopup !== null ? isHalfSheetPopup.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageDependentSavingsHomeUpsellSectionButtonTappedEvent
 */
export var SavingsFolderManageDependentSavingsHomeUpsellSectionButtonTapped = function (_a) {
    var eventType = _a.eventType, yieldStatus = _a.yieldStatus, isHalfSheetPopup = _a.isHalfSheetPopup;
    return ({
        name: "SavingsFolder Manage DependentSavingsHomeUpsellSectionButtonTapped",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            event_type: eventType !== undefined && eventType !== null ? eventType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            yield_status: yieldStatus !== undefined && yieldStatus !== null ? yieldStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_half_sheet_popup: isHalfSheetPopup !== undefined && isHalfSheetPopup !== null ? isHalfSheetPopup.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageSetGoalStartEvent
 */
export var SavingsFolderManageSetGoalStart = function () { return ({
    name: "SavingsFolder Manage SetGoalStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageTapSavingsFolderItemEvent
 */
export var SavingsFolderManageTapSavingsFolderItem = function (_a) {
    var folderType = _a.folderType, goalToken = _a.goalToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder Manage TapSavingsFolderItem",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            folder_type: folderType !== undefined && folderType !== null ? folderType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goal_token: goalToken !== undefined && goalToken !== null ? goalToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageUpdateGoalStartEvent
 */
export var SavingsFolderManageUpdateGoalStart = function () { return ({
    name: "SavingsFolder Manage UpdateGoalStart",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageViewActivityEvent
 */
export var SavingsFolderManageViewActivity = function (_a) {
    var paymentId = _a.paymentId, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder Manage ViewActivity",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            payment_id: paymentId !== undefined && paymentId !== null ? paymentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageViewAllActivityEvent
 */
export var SavingsFolderManageViewAllActivity = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SavingsFolder Manage ViewAllActivity",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderManageYieldEnrollmentViewAboutInterestEvent
 */
export var SavingsFolderManageYieldEnrollmentViewAboutInterest = function () { return ({
    name: "SavingsFolder Manage YieldEnrollmentViewAboutInterest",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "Manage",
    }
}); };
/**
 * @see SavingsFolderManageYieldEnrollmentSuccessEvent
 */
export var SavingsFolderManageYieldEnrollmentSuccess = function (_a) {
    var yieldStatus = _a.yieldStatus;
    return ({
        name: "SavingsFolder Manage YieldEnrollmentSuccess",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "Manage",
            yield_status: yieldStatus !== undefined && yieldStatus !== null ? yieldStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferInStartEvent
 */
export var SavingsFolderTransferInStart = function (_a) {
    var origin = _a.origin, subBalanceToken = _a.subBalanceToken;
    return ({
        name: "SavingsFolder TransferIn Start",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "TransferIn",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sub_balance_token: subBalanceToken !== undefined && subBalanceToken !== null ? subBalanceToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferInViewInstrumentSelectionBlockerForSourceEvent
 */
export var SavingsFolderTransferInViewInstrumentSelectionBlockerForSource = function () { return ({
    name: "SavingsFolder TransferIn ViewInstrumentSelectionBlockerForSource",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferInViewInstrumentSelectionBlockerForDestinationEvent
 */
export var SavingsFolderTransferInViewInstrumentSelectionBlockerForDestination = function () { return ({
    name: "SavingsFolder TransferIn ViewInstrumentSelectionBlockerForDestination",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferInChooseAmountEvent
 */
export var SavingsFolderTransferInChooseAmount = function (_a) {
    var selectionType = _a.selectionType, amountCents = _a.amountCents, currencyCode = _a.currencyCode;
    return ({
        name: "SavingsFolder TransferIn ChooseAmount",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "TransferIn",
            selection_type: selectionType !== undefined && selectionType !== null ? selectionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_cents: amountCents !== undefined && amountCents !== null ? amountCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferInConfirmEvent
 */
export var SavingsFolderTransferInConfirm = function () { return ({
    name: "SavingsFolder TransferIn Confirm",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferInViewPinOrBiometricEvent
 */
export var SavingsFolderTransferInViewPinOrBiometric = function () { return ({
    name: "SavingsFolder TransferIn ViewPinOrBiometric",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferInEnterPinOrBiometricSuccessfullyEvent
 */
export var SavingsFolderTransferInEnterPinOrBiometricSuccessfully = function () { return ({
    name: "SavingsFolder TransferIn EnterPinOrBiometricSuccessfully",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferInCompleteSuccessfullyEvent
 */
export var SavingsFolderTransferInCompleteSuccessfully = function (_a) {
    var isFirstTransfer = _a.isFirstTransfer;
    return ({
        name: "SavingsFolder TransferIn CompleteSuccessfully",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "TransferIn",
            is_first_transfer: isFirstTransfer !== undefined && isFirstTransfer !== null ? isFirstTransfer.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferInDenylistedEvent
 */
export var SavingsFolderTransferInDenylisted = function () { return ({
    name: "SavingsFolder TransferIn Denylisted",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferIn",
    }
}); };
/**
 * @see SavingsFolderTransferOutStartEvent
 */
export var SavingsFolderTransferOutStart = function (_a) {
    var origin = _a.origin, subBalanceToken = _a.subBalanceToken;
    return ({
        name: "SavingsFolder TransferOut Start",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "TransferOut",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sub_balance_token: subBalanceToken !== undefined && subBalanceToken !== null ? subBalanceToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferOutViewInstrumentSelectionBlockerForSourceEvent
 */
export var SavingsFolderTransferOutViewInstrumentSelectionBlockerForSource = function () { return ({
    name: "SavingsFolder TransferOut ViewInstrumentSelectionBlockerForSource",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderTransferOutViewInstrumentSelectionBlockerForDestinationEvent
 */
export var SavingsFolderTransferOutViewInstrumentSelectionBlockerForDestination = function () { return ({
    name: "SavingsFolder TransferOut ViewInstrumentSelectionBlockerForDestination",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderTransferOutChooseAmountEvent
 */
export var SavingsFolderTransferOutChooseAmount = function (_a) {
    var selectionType = _a.selectionType, amountCents = _a.amountCents, currencyCode = _a.currencyCode;
    return ({
        name: "SavingsFolder TransferOut ChooseAmount",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "TransferOut",
            selection_type: selectionType !== undefined && selectionType !== null ? selectionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_cents: amountCents !== undefined && amountCents !== null ? amountCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsFolderTransferOutViewPinOrBiometricEvent
 */
export var SavingsFolderTransferOutViewPinOrBiometric = function () { return ({
    name: "SavingsFolder TransferOut ViewPinOrBiometric",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderTransferOutEnterPinOrBiometricSuccessfullyEvent
 */
export var SavingsFolderTransferOutEnterPinOrBiometricSuccessfully = function () { return ({
    name: "SavingsFolder TransferOut EnterPinOrBiometricSuccessfully",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderTransferOutConfirmEvent
 */
export var SavingsFolderTransferOutConfirm = function () { return ({
    name: "SavingsFolder TransferOut Confirm",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderTransferOutCompleteSuccessfullyEvent
 */
export var SavingsFolderTransferOutCompleteSuccessfully = function () { return ({
    name: "SavingsFolder TransferOut CompleteSuccessfully",
    parameters: {
        cdf_entity: "SavingsFolder",
        cdf_action: "TransferOut",
    }
}); };
/**
 * @see SavingsFolderYieldPaymentReceiveEvent
 */
export var SavingsFolderYieldPaymentReceive = function (_a) {
    var isFirstYieldPayment = _a.isFirstYieldPayment, interestRateTier = _a.interestRateTier;
    return ({
        name: "SavingsFolder YieldPayment Receive",
        parameters: {
            cdf_entity: "SavingsFolder",
            cdf_action: "YieldPayment",
            is_first_yield_payment: isFirstYieldPayment !== undefined && isFirstYieldPayment !== null ? isFirstYieldPayment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            interest_rate_tier: interestRateTier !== undefined && interestRateTier !== null ? interestRateTier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
